export const defaultSorted = [{ dataField: "sentDate", order: "asc" }];

export const sizePerPageList = [
  { text: "3", value: 3 },
  { text: "5", value: 5 },
  { text: "10", value: 10 },
];
export const initialFilter = {
  filter: {
    objectDataSearchKey: "",
  },
  sortOrder: "sentDate", // asc||desc
  sortField: "asc",
  pageNumber: 1,
  pageSize: 10,
};